// extracted by mini-css-extract-plugin
export default {"search-container":"Search_search-container__GnFq0","search-icon":"Search_search-icon__bSpYE","search-input":"Search_search-input__Kxz61"};